export const POPUP_SEEN_KEY = "hsv-popup-seen";
